const AccountingFirmSecuritySettings = () => import('@/components/Settings/AccountingFirmSecuritySettings')

export default [
	{
		component: AccountingFirmSecuritySettings,
		name: 'accounting-firm-settings-security',
		path: 'security'
	}
]
